import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0401b833")

_pushScopeId("data-v-0401b833")
const _hoisted_1 = { class: "patient-row" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", null, "予約日時", -1)
const _hoisted_3 = { class: "patient-date" }
const _hoisted_4 = { class: "patient-row" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h3", null, "予約患者名", -1)
const _hoisted_6 = {
  key: 0,
  class: "patient-name"
}
const _hoisted_7 = {
  key: 1,
  class: "appointment-not-selected"
}
const _hoisted_8 = { class: "patient-row" }
const _hoisted_9 = /*#__PURE__*/_createVNode("h3", null, "担当医", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("先生 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_select_box = _resolveComponent("select-box")
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, null, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.baseDateString), 1)
      ]),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        (_ctx.patientInfo !=='')
          ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(_ctx.patientInfo), 1))
          : (_openBlock(), _createBlock("div", _hoisted_7, "カルテを閲覧または作成したい患者を、右のタイムテーブルから選択してください。"))
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_select_box, {
          title: "account",
          items: _ctx.accounts,
          modelValue: _ctx.selectedAccount,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedAccount = $event))
        }, {
          default: _withId(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["items", "modelValue"])
      ])
    ]),
    _: 1
  }))
})